import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {createReservation as createReservationAPI} from '../../../services/reservations'
import fixture from '../../../fixtures/reservations/get-configuration.json'

export async function createReservation(dispatch, reservationData) {
  try {
    dispatch({type: PENDING})
    let response = await createReservationAPI(reservationData)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed: ${reservationData}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function resetReservation(dispatch) {
  dispatch({type: RESET})
}
